import RenderforestIcon from 'assets/svgr-icons/Render.svg'
import KlingIcon from 'assets/svgr-icons/Kling.svg'
import SeedanceIcon from 'assets/svgr-icons/Seedance.svg'
import PixverseIcon from 'assets/svgr-icons/Pixverse.svg'
import GoogleIcon from 'assets/svgr-icons/Google.svg'
import HailuoIcon from 'assets/svgr-icons/Hailuo.svg'
import FluxIcon from 'assets/svgr-icons/Flux.svg'
import { IGroupMeta } from 'containers/SubSidebar/shared/GroupedModelDropdown'

export const AI_VIDEO_MODEL_GROUP_META: Record<string, IGroupMeta> = {
  renderforest: {
    label: 'Renderforest',
    order: 1,
    Icon: RenderforestIcon
  },
  kling: {
    label: 'Kling',
    order: 2,
    Icon: KlingIcon
  },
  bytePlus: {
    label: 'Seedance',
    order: 3,
    Icon: SeedanceIcon
  },
  pixVerse: {
    label: 'Pixverse',
    order: 4,
    Icon: PixverseIcon
  },
  google: {
    label: 'Veo',
    order: 5,
    Icon: GoogleIcon
  },
  miniMax: {
    label: 'Hailuo',
    order: 6,
    Icon: HailuoIcon
  },
  flux: {
    label: 'Flux',
    order: 7,
    Icon: FluxIcon
  }
}

export const RENDERFOREST_FAST_MODEL = 'forest-1.0'

export const RENDERFOREST_GROUP_KEY = 'renderforest'
